import React, { useState } from 'react';

export function AdminLogin({ onLogin }) {
  const [pwd, setPwd] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!pwd.trim()) return;
    setLoading(true); setError('');
    const res = await fetch('/.netlify/functions/get-orders', {
      headers: { Authorization: `Bearer ${pwd}` },
    });
    if (res.status === 401) { setError('Wrong password. Try again.'); setLoading(false); return; }
    if (!res.ok) { setError('Something went wrong. Try again.'); setLoading(false); return; }
    onLogin(pwd);
  }

  return (
    <div className="admin-login-wrap">
      <div className="admin-login-box">
        <img src="/logo.webp" alt="Kiane" className="admin-logo" />
        <h2>Admin Dashboard</h2>
        <p>Enter your admin password to continue</p>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="Admin password"
            value={pwd}
            onChange={e => setPwd(e.target.value)}
            className="admin-pwd-input"
            autoFocus
          />
          {error && <p className="admin-error">{error}</p>}
          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? 'Verifying…' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
